export default __webpack_public_path__ + "static/media/img2.46f46a96.jpg";